import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import steve from "../../../assets/advisory/steve.jpg";
import prof from "../../../assets/advisory/prof.png";
import lekan from "../../../assets/team/lekan.png";
import edna from "../../../assets/advisory/edna.png";
import adeni from "../../../assets/team/adeni.jpg";

const data = [
  {
    imgpath: steve,
    name: "Steve Okeleji",
    title: "Executive Director",
    profile:
      "Steve Okeleji's personal journey in aquaculture took off in 2006, during his second year of studying Aquaculture and Fisheries Management at the Federal University of Agriculture in Ogun State, Nigeria, when he founded Fish Shoal Nigeria. Currently a scholar at the Netherlands Business School, Steve was recognized by the World Bank in 2017 as a Young Aquaculture Innovator for his groundbreaking work in Africa. In 2018, the International Food Policy Research Institute (IFPRI) in Washington, D.C., featured him as a case study for aquaculture development in Africa. In 2021, African Impact awarded him “African Champion for the Year in Agricultural Development” in Accra, Ghana. Steve also serves as a member of the United Nations Private Sector Advisory Group.",
  },
  {
    imgpath: prof,
    name: "Prof. Yemi Akegbejo-Samsons",
    title: "Lead Consultant",
    profile:
      "The consulting team for Aquatic Hub Afrique Network is led by Prof. Yemi Akegbejo-Samsons, a seasoned expert in aquaculture and coastal fisheries management with over three decades of experience managing and conserving tropical water resources in Nigeria and beyond. As a Professor of Aquaculture and Coastal Fisheries at the Federal University of Agriculture, Abeokuta, Nigeria, Prof. Akegbejo-Samsons brings a wealth of expertise in stock assessment and sustainable fisheries management within both coastal and inland fisheries contexts.",
  },
  {
    imgpath: edna,
    name: "Edna Eligado Dionisio",
    title: "Technical Director",
    profile:
      "Edna Eligado Dionisio is a distinguished expert in aquaculture and fisheries, boasting over 33 years of comprehensive experience in stock assessment and fishery management. With a Masters Degree in Aquaculture and specialized knowledge in fish breeding and genetics, Edna has dedicated her career to enhancing sustainable practices within the aquaculture industry. Her role as a leader in various fisheries projects has equipped her with profound insights into the complexities of fish population dynamics and the ecological challenges associated with aquatic resource management.",
  },
  {
    imgpath: lekan,
    name: "Olaleken Adeleke",
    title: "Head of Programs",
    profile:
      "Olalekan Adeleke is a goal-oriented professional with a strong foundation in data analysis, project management, and artificial intelligence. With a Bachelor of Technology in Statistics and an MBA, he possesses profound knowledge of planning, organizing, and leading complex marine and blue economy projects. Olalekan is a fellow of the African Drone and Data Academy (ADDA) in Malawi, he has demonstrated exceptional analytical prowess in data visualization and interpretation, utilizing advanced analytics tools to drive insights in stock assessment and fisheries management. ",
  },
  {
    imgpath: adeni,
    name: "Adeni Olugbenga Ebenezer ",
    title: "Head of Operations",
    profile:
      "Adeni Olugbenga is a highly accomplished professional banker with over twenty years of banking experience. He has held functional roles in banking operations, banking marketing, and branch audit with remarkable achievements. Olugbenga holds a Bachelor of Science in Banking and Finance from Olabisi Onabanjo University, Ago-Iwoye, Ogun State, and he is also an Associate of the Chartered Institute of Bankers of Nigeria. Currently, Olugbenga serves as the Head of Operations, AHAN, where he continues to lead efforts in promoting sustainable aquaculture practices in emerging economies.",
  },
];

const Management = () => {
  return (
    <Box margin={{ xs: "10% 0% 25% 0%", sm: "4% 0% 15% 0%" }}>
      <Typography
        variant={"h3"}
        fontWeight={900}
        textAlign={"left"}
        color={"#00AEEF"}
        paddingBottom={"1%"}
      >
        <Typography
          component={"span"}
          variant={"h3"}
          color="#3E4095"
          fontWeight={900}
        >
          Our {""}
        </Typography>
        Core Team
      </Typography>
      <Typography
        variant={"body1"}
        fontWeight={400}
        textAlign={"left"}
        color={"#000"}
        paddingBottom={"2%"}
      >
        Meet the dedicated team behind Aquatic Hub Afrique Network, a group of
        experts with a shared commitment to transforming aquaculture and
        fisheries in Africa. With years of combined experience spanning
        technical innovation, sustainable resource management, and program
        leadership, our core team is equipped to tackle the unique challenges
        facing aquatic ecosystems and coastal communities. Together, they work
        tirelessly to deliver solutions that foster sustainable growth, empower
        local stakeholders, and protect vital marine and freshwater resources
        across the continent.
      </Typography>
      <Grid container spacing={1}>
        {data.map((list, index) => {
          const { imgpath, name, title, profile } = list;
          return (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                marginTop={{ xs: "10%", sm: "3%" }}
                key={index}
              >
                <Card sx={{ maxWidth: 360, height: "100%" }}>
                  <CardMedia
                    component="img"
                    height="340"
                    image={imgpath}
                    sx={{ objectFit: "cover" }}
                    alt={name}
                  />
                  <CardContent>
                    <Typography
                      gutterBottom
                      variant="h5"
                      color={"#3E4095"}
                      component="div"
                      fontWeight={700}
                      paddingBottom={"1%"}
                    >
                      {name}
                    </Typography>
                    <Typography
                      paddingBottom={"2%"}
                      variant="body2"
                      color="#00AEEF"
                      fontWeight={700}
                      data-aos={"fade-up"}
                    >
                      {title}
                    </Typography>
                    <Typography
                      paddingBottom={"5%"}
                      variant="body1"
                      color="text.secondary"
                      data-aos={"fade-up"}
                    >
                      {profile}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </>
          );
        })}
      </Grid>
    </Box>
  );
};

export default Management;
